import { Navigate } from "react-router-dom"

import { MANAGEMENT } from "@/constants"

export const Home = () => {
  return <Navigate to={MANAGEMENT} replace />
}
